import clsx from 'clsx'
import React from 'react'

import { makeStyles } from '@material-ui/core/styles'
import { Paper } from '@material-ui/core'

const useStyles = makeStyles(({ spacing }) => ({
  paddedPaper: { padding: padSpacing => spacing(padSpacing) },
}))

export default function PaddedPaper({ padSpacing = 2, className, ...rest }) {
  const classes = useStyles(padSpacing)
  // Todo: most likely need to combine className with rest.className
  return <Paper className={clsx(classes.paddedPaper, className)} {...rest} />
}
